// Mock-Daten für Sofia Laitenberger Landing Page

export const heroData = {
  name: "Sofia Laitenberger",
  location: "Hamburg / Lissabon",
  headline: "Rechtssichere KI und Compliance – Juristische Beratung für die digitale Transformation",
  headlinePart1: "Rechtssichere KI und Compliance",
  headlinePart2: "Beratung für die digitale Transformation",
  subline: "Juristische Expertise trifft K\xFCnstliche Intelligenz.\nSpezialisiert auf Wirtschaftsrecht, Verwaltungsrecht, AI Governance, IT-Recht und Compliance begleite ich Unternehmen und \xF6ffentliche Institutionen bei der rechtssicheren digitalen Transformation und Einf\xFChrung innovativer KI-L\xF6sungen.",
  bulletPoints: [
  "Juristin mit interdisziplinärer Expertise in Wirtschaftsrecht, Compliance und KI-gestützter Prozessoptimierung",
  "Spezialisiert auf die Implementierung von KI-Systemen, Automatisierung von Geschäftsprozessen und datenschutzkonforme Digitalisierung",
  "Erfahrung in öffentlichen Verwaltungsprozessen, Verfahrenssteuerung und rechtlicher Fallbearbeitung"],

  image: "https://customer-assets.emergentagent.com/job_ki-governance-legal/artifacts/dmhep41s_ChatGPT%20Image%2012.%20Juni%202026%2C%2014_45_09.png",
  linkedinUrl: "https://www.linkedin.com/in/sofia-laitenberger-2a6576155/?locale=de_DE"
};

export const servicesData = {
  forCompanies: {
    title: "Für Unternehmen & Organisationen",
    services: [
    {
      title: "Rechtssichere KI-Implementierung & KI-Governance",
      description: "Strategische Beratung für den verantwortungsvollen Einsatz von KI-Systemen"
    },
    {
      title: "Compliance & IT-Recht",
      description: "Datenschutz, digitale Verwaltungsprozesse, Marketing & IT-Compliance"
    },
    {
      title: "Brand Growing und Management",
      description: "Strategische Markenentwicklung und ganzheitliches Markenmanagement"
    },
    {
      title: "Omnichannel Management",
      description: "Nahtlose Kundeninteraktionen über alle Kanäle hinweg"
    },
    {
      title: "Workshops & Schulungen",
      description: "Praxisnahe Trainings zu KI, IT-Recht und Compliance-Themen"
    }]

  },
  forPrivateClients: {
    title: "Für Privatkunden",
    services: [
    {
      title: "Karriereeinstieg & Lebenslauf-Optimierung",
      description: "Professionelle Überarbeitung und strategische Optimierung Ihres Lebenslaufs für den erfolgreichen Berufseinstieg. Besonders geeignet für Absolventinnen und Absolventen aus den Bereichen Finanzen, Wirtschaft und verwandten Fachrichtungen, die ihre Qualifikationen überzeugend präsentieren möchten."
    },
    {
      title: "Bewerbungsunterlagen professionell optimieren",
      description: "Umfassende Analyse und Optimierung Ihrer Bewerbungsunterlagen – vom Lebenslauf über das Anschreiben bis hin zu ergänzenden Dokumenten. Individuell auf die jeweilige Position und den gewünschten Arbeitgeber abgestimmt."
    },
    {
      title: "Persönliche Karriereberatung",
      description: "Individuelle Beratung zur optimalen Darstellung Ihrer fachlichen und persönlichen Stärken. Gemeinsam arbeiten wir heraus, wie Sie Ihr Profil schärfen, Ihre Erfahrungen wirkungsvoll präsentieren und Ihre Chancen im Bewerbungsprozess nachhaltig steigern."
    }]

  },
  forEmployers: {
    title: "Für Arbeitgeber",
    services: [
    {
      title: "Juristische Bearbeitung",
      description: "Effiziente juristische Fallbearbeitung – DSGVO-konform und rechtsgebietsübergreifend"
    },
    {
      title: "Expertise in allen Rechtsgebieten",
      description: "Gutachten, Fallbearbeitung und rechtliche Analysen"
    },
    {
      title: "Schnittstelle Recht & Technologie",
      description: "Akten Pseudonymisierung und Digitale Workflows"
    },
    {
      title: "Effiziente Bearbeitung",
      description: "Sehr genaue und zügige Bearbeitung durch den Einsatz von KI Tools und KI Agents, Aktenorganisation und Mandantenbetreuung"
    }]

  },
  forLawFirms: {
    title: "Für Kanzleien",
    services: [
    {
      title: "Digitale Fallbearbeitung & Aktenmanagement",
      description: "Effiziente Unterstützung bei der digitalen Bearbeitung von Mandaten durch strukturierte Aktenorganisation, datenschutzkonforme Pseudonymisierung sensibler Daten sowie die Optimierung juristischer Arbeitsabläufe durch moderne digitale Workflows."
    },
    {
      title: "Prozessoptimierung für Kanzleien",
      description: "Analyse, Strukturierung und Digitalisierung wiederkehrender Kanzleiprozesse zur Steigerung von Effizienz, Transparenz und Bearbeitungsgeschwindigkeit – von der Mandatsannahme bis zur Fallverwaltung."
    },
    {
      title: "KI-gestützte Workflow-Implementierung",
      description: "Konzeption und Einführung DSGVO-konformer KI- und Automatisierungslösungen zur Unterstützung administrativer und organisatorischer Tätigkeiten. Ziel ist die Entlastung von Fachkräften und die Schaffung effizienter, nachvollziehbarer Arbeitsabläufe."
    }]

  }
};

export const whyMeData = {
  title: "Was mich auszeichnet",
  points: [
  {
    title: "Z\xFCgige Kompetenz",
    description: "Effiziente und DSGVO-konforme Fallbearbeitung durch digitale Workflows, Aktenpseudonymisierung und den Einsatz moderner KI-gest\xFCtzter Arbeitsmethoden."
  },
  {
    title: "Schnittstelle Recht & Technologie",
    description: "Verbindet juristische Expertise, beh\xF6rdliche Praxiserfahrung und KI-Kompetenz zu rechtssicheren digitalen L\xF6sungen."
  },
  {
    title: "Vertrauensbasis",
    description: "Vertrauen durch umfassende Erfahrung in öffentlichen Institutionen, komplexen Rechtsverfahren und individueller Rechtsberatung. Langjährige Erfahrung in der Zusammenarbeit mit Coaches, Personalverantwortlichen und Fachkräften aus der Finanz- und Wirtschaftswelt."
  },
  {
    title: "International & mehrsprachig",
    description: "Internationale Erfahrung im juristischen und beh\xF6rdlichen Umfeld sowie ausgepr\xE4gte interkulturelle Kompetenz durch Mehrsprachigkeit."
  }]

};

export const aboutData = {
  title: "Über mich",
  story: [
  "Mein beruflicher Werdegang verbindet juristische Expertise, unternehmerisches Denken und technologische Innovation. Nach meiner Tätigkeit im Projektmanagement und digitalen Umfeld entschied ich mich für das Studium der Rechtswissenschaften und spezialisierte mich auf die Analyse komplexer rechtlicher Fragestellungen sowie die Entwicklung tragfähiger materiell- und prozessrechtlicher Strategien.",
  "Heute berate ich an der Schnittstelle von Recht, Technologie und Digitalisierung. Mein Schwerpunkt liegt im Wirtschaftsrecht, Compliance, KI-Recht sowie der rechtssicheren Gestaltung digitaler Prozesse. Dank meiner breiten juristischen Ausbildung und langjährigen Praxiserfahrung bin ich in der Lage, anspruchsvolle Rechtsgutachten und strategische Handlungsempfehlungen in unterschiedlichsten Rechtsgebieten effizient, präzise und lösungsorientiert zu entwickeln.",
  "Besonders am Herzen liegt mir die Modernisierung juristischer Arbeitsprozesse. Durch digitale Archivierung, DSGVO-konforme Aktenpseudonymisierung und KI-gestützte Workflows lassen sich juristische Recherchen, Dokumentenanalysen und Fallbearbeitungen erheblich beschleunigen. Die dadurch gewonnene Zeit kann gezielt in die Entwicklung innovativer Rechtsstrategien, die persönliche Mandantenbetreuung und den Ausbau des Geschäftserfolgs investiert werden.",
  "Ich bin überzeugt, dass die Zukunft erfolgreicher Rechtsberatung nicht allein in juristischer Fachkompetenz liegt, sondern in der intelligenten Verbindung von Recht, Technologie und effizienten Prozessen. Mein Anspruch ist es, diese Zukunft aktiv mitzugestalten und für Mandanten einen echten Mehrwert zu schaffen."]

};

export const competenciesData = {
  legal: {
    title: "Recht & Compliance",
    icon: "scale",
    items: [
    "Wirtschaftsrecht",
    "KI-Recht & AI Governance",
    "IT-Recht & Datenschutz",
    "Verwaltungs- und Verfahrensrecht",
    "Widerspruchs- und Rechtsmittelverfahren",
    "Compliance & Regulatory Affairs"]

  },
  ai: {
    title: "KI, Digitalisierung & Innovation",
    icon: "brain",
    items: [
    "KI-Systemimplementierung",
    "KI-gestützte Prozessautomatisierung",
    "Datenanalyse & intelligente Workflows",
    "Digitale Verwaltungs- und Geschäftsprozesse",
    "Dokumentenmanagement & Aktenpseudonymisierung",
    "Digitale Transformation & Prozessoptimierung"]

  },
  strategy: {
    title: "Strategie, Management & Transformation",
    icon: "trending-up",
    items: [
    "Projekt- und Programmmanagement",
    "Organisationsentwicklung",
    "Change Management",
    "Digitale Geschäftsmodelle",
    "Marken- und Kommunikationsstrategie",
    "Stakeholder-Management"]

  },
  tech: {
    title: "Technologien & Digitale Werkzeuge",
    icon: "settings",
    items: [
    "KI-Agenten & Large Language Models (LLMs)",
    "CRM- und Workflow-Systeme",
    "Microsoft 365 & Kollaborationsplattformen",
    "Design-, Präsentations- und Visualisierungstools",
    "Content- und Wissensmanagement",
    "Automatisierungs- und Produktivitätstools"]

  }
};

export const referencesData = {
  title: "Referenzen & Vertrauen",
  institutions: [
  "Bundesagentur für Arbeit",
  "Zahnärztekammer Niedersachsen",
  "Bundesministerium für Gesundheit",
  "Amt für Migration Hamburg",
  "IXL Germany",
  "IXL London"],

  testimonials: [
  {
    text: "Sofia verbindet juristisches Know-how mit technischem Verständnis – eine seltene und wertvolle Kombination.",
    author: "Dr. Jens Meyer",
    position: "Gesch\xE4ftsf\xFChrer, TechStuff GmbH"
  },
  {
    text: "Ihre Fähigkeit, komplexe KI-Themen rechtlich einzuordnen und verständlich zu kommunizieren, ist beeindruckend.",
    author: "Dr. Anna Langeloh",
    position: "Leiterin Compliance, TechStuff GmbH"
  },
  {
    text: "Professionell, zuverlässig und mit einem ausgeprägten Gespür für praktische Lösungen.",
    author: "Thomas Landruth",
    position: "Abteilungsleiter, Öffentliche Verwaltung"
  }]

};

export const contactData = {
  title: "Kontakt & Zusammenarbeit",
  intro: "Sie suchen eine Juristin oder Consultant an der Schnittstelle von Recht, KI und Compliance? Lassen Sie uns sprechen.",
  email: "info@brainhurricane.org",
  linkedinUrl: "https://www.linkedin.com/in/sofia-laitenberger-2a6576155/?locale=de_DE",
  organizationTypes: [
  { value: "unternehmen", label: "Unternehmen" },
  { value: "verwaltung", label: "Öffentliche Verwaltung" },
  { value: "kanzlei", label: "Kanzlei" },
  { value: "privat", label: "Privat" }]

};